import React from 'react';

const SVG = ({ style = {}, color = 'rgb(255, 255, 255)', width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <path d="M 50,21 L 82,51 72,51 72,75 57,75 57,57 42,57 42,75 27,75 27,51 17,51 Z" stroke={color} strokeWidth={5} fill="none" />
    </g>
  </svg>
);

export default SVG;
